export type ToolCallResultStatus = "success" | "empty" | "error";

/** Monospace tool name + `()` in tool-call indicators. */
export const TOOL_CALL_INDICATOR_NODE_TITLE_CLASS = "font-mono text-dark";

export const LOAD_SKILL_TOOL_NAME = "load_skill";

/** Body patterns that indicate load_skill failed even when `isError` is false. */
export const LOAD_SKILL_BODY_ERROR_PATTERN = /not found|is not a skill/i;

export const COMPLETED_SUMMARY_STATUS_LABEL: Record<ToolCallResultStatus, string> = {
  success: "",
  empty: "Empty (404)",
  error: "Error",
};

export const RESULT_STATUS_STYLES: Record<
  ToolCallResultStatus,
  {
    border: string;
    background: string;
    statusDot: string;
    statusText: string;
    arrowIcon: string;
  }
> = {
  success: {
    border: "border-success-light",
    background: "bg-success-lightest dark:bg-success-main",
    statusDot: "bg-success dark:bg-success-lightest",
    statusText: "text-success-dark",
    arrowIcon: "text-success",
  },
  empty: {
    border: "border-warning-light",
    background: "bg-warning-lightest dark:bg-warning-main",
    statusDot: "bg-warning dark:bg-warning-lightest",
    statusText: "text-warning-dark dark:text-warning-light",
    arrowIcon: "text-warning",
  },
  error: {
    border: "border-error-light",
    background: "bg-error-lightest dark:bg-error-main",
    statusDot: "bg-error dark:bg-error-lightest",
    statusText: "text-error dark:text-error-light",
    arrowIcon: "text-error",
  },
};
